import script from "./Installrole.vue?vue&type=script&setup=true&lang=js"
export * from "./Installrole.vue?vue&type=script&setup=true&lang=js"

import "./Installrole.vue?vue&type=style&index=0&id=2733f303&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2733f303"]])

export default __exports__